type RuleProps = {
    className?: string;
};

export default function Rule({ className = null }: RuleProps) {
    return <hr className={`border-0 bg-primary h-[3px] ${className}`}></hr>;
}
